/**
 * @class InvoicePaymentSubject
 */
export class InvoicePaymentSubject {
  /**
   * @param {object} [payload]
   * @param {number} payload.id
   * @param {string} payload.description
   * @param {number} payload.count
   * @param {number} payload.discount
   * @param {string} payload.type
   * @param {Service, ServiceGroup} payload.subject
   */
  constructor(payload) {
    this._id = Math.random();
    this.id = payload?.id ?? null;
    this.description = payload?.description ?? null;
    this.count = payload?.count ?? 1;
    this.discount = payload?.discount ?? 0;
    this.type = payload?.type ?? null;
    this.subject = payload?.subject ?? null;
  }

  static enum = {
    types: {
      Service: 'service',
      GroupService: 'group_service',
    },
  };
}
